import KT01BaseLayout from 'general/components/BaseLayout/KT01BaseLayout';
import { Route, Routes } from 'react-router-dom';
import TransactionHistoryScreen from './screens/TransactionHistoryScreen';

ManageTransactionHistory.propTypes = {};

function ManageTransactionHistory(props) {
    return (
        <KT01BaseLayout isFullScreen={true}>
            <div className="container-fluid px-4 my-4">
                <Routes>
                    <Route path="" element={<TransactionHistoryScreen />} />
                    <Route path="*" element={<>Not found</>} />
                </Routes>
            </div>
        </KT01BaseLayout>
    );
}

export default ManageTransactionHistory;
